export const isImg = (mimeType: string) => {
    if (!mimeType) return false;
    return mimeType.startsWith('image');
};
